// src/pages/ProfilePage.jsx
import React from "react";
import {
  Container,
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useNavigate } from "react-router-dom";
import LogoHeader from "../components/LogoHeader";

export default function ProfilePage() {
  const navigate = useNavigate();
  const [user, setUser] = React.useState(null);

React.useEffect(() => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  setUser(storedUser);
}, []);

  const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000";


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleOpenSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseSettings = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
  // 🔐 Clear auth
  localStorage.removeItem("user");

  // 🔥 HARD RESET all moment-related state
  sessionStorage.removeItem("active_moment_id");
  sessionStorage.removeItem("moment_suppressed");

  // Clear any other moment leftovers
  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith("moment_")) {
      sessionStorage.removeItem(key);
    }
  });

  // 🔔 Notify app to reset presence UI
  window.dispatchEvent(new Event("moment-ended"));
  window.dispatchEvent(new Event("moment-suppress"));
  window.dispatchEvent(new Event("go-home"));

  // 🚪 Go to login
  navigate("/login", { replace: true });
};


  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        px: 1.5,
        pb: 10,
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* ===== SAFE AREA TOP ===== */}
      <Box sx={{ pt: "env(safe-area-inset-top)", pb: 1 }}>
        {/* ===== APP HEADER ===== */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <LogoHeader />

          <IconButton onClick={handleOpenSettings} sx={{ p: 0.5 }}>
            <SettingsIcon sx={{ fontSize: 20, color: "#6B7280" }} />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseSettings}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem
              onClick={() => {
                handleCloseSettings();
                navigate("/profile/edit");
              }}
            >
              Edit Profile
            </MenuItem>

           

            <MenuItem
              onClick={() => {
                handleCloseSettings();
                handleLogout();
              }}
              sx={{ color: "error.main", fontWeight: 600 }}
            >
              Log out
            </MenuItem>
          </Menu>
        </Box>

        {/* ===== PROFILE ROW ===== */}
        {/* ===== PROFILE ROW ===== */}
<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    mt: 1,
  }}
>
  {/* Avatar */}
  <Avatar
    src={
      user?.profilePic
        ? user.profilePic.startsWith("http")
          ? user.profilePic
          : `${API_BASE}${user.profilePic}`
        : undefined
    }
    sx={{
      width: 80,
      height: 80,
      mb: 1,
      border: "1px solid #E5E7EB",
      bgcolor: "#E5E7EB",
    }}
  />

            <Typography
            sx={{
              fontSize: { xs: "1.85rem", sm: "1.6rem" },

              fontWeight: 800,
              color: "#111827",
              mt: 0.25,
              lineHeight: 1.15,
            }}
          >
            {user?.username ? `${user.username}` : ""}
          </Typography>

  

  

</Box>

        </Box>
      

      
      
    </Container>
  );
}
